import { createHandlerChainRunnerOptionalParameter, Handler } from "@insite/client-framework/HandlerCreator";

export const ClearSelectedVmiBins: Handler = props => {
    props.dispatch({
        type: "Pages/VmiBins/ClearVmiItemChecks",
    });
};

export const chain = [ClearSelectedVmiBins];

const clearSelectedVmiBins = createHandlerChainRunnerOptionalParameter(chain, {}, "ClearSelectedVmiBins");
export default clearSelectedVmiBins;
